


























import Vue from "vue";
import OnlineCard from "@/components/Page/Overview/OnlineCard.vue";
import DeviceStatusCard from "@/components/Page/Overview/DeviceStatusCard.vue";
import DeviceByDaysCard from "@/components/Page/Overview/DeviceByDaysCard.vue";
import DeviceCategoryCard from "@/components/Page/Overview/DeviceCategoryCard.vue";
import DeviceDisponibilityCard from "@/components/Page/Overview/DeviceDisponibilityCard.vue";
import DeviceMainStatusCard from "@/components/Page/Overview/DeviceMainStatusCard.vue";
import LogsCard from "@/components/Page/Overview/LogsCard.vue";

export default Vue.extend({
  name: "Overview",
  components: {
    OnlineCard,
    DeviceStatusCard,
    DeviceByDaysCard,
    DeviceDisponibilityCard,
    DeviceCategoryCard,
    LogsCard,
    DeviceMainStatusCard
  }
});
